import { AppModal } from '@/components/compose/app.modal';
import styled from 'styled-components/native';
import { useCallback, useState } from 'react';
import { AppTextView } from '@/components/base/app.text.view';
import { Box } from '@/components/base/box';
import { AppButton } from '@/components/base/app.button';
import { useActiveVisit } from '@/hooks/use.active.visit';
import { AppSwitch } from '@/components/base/app.switch';
import { useUser } from '@/hooks/use.user';
import { UserTypeEnum } from '@matap/shared';
import { useEndVisit } from '@/apis/visit';
import { useNavigation } from '@react-navigation/native';

export default function EndVisitConfirmationModal() {
  const navigation = useNavigation();
  const { activeVisitId } = useActiveVisit();
  const { userType } = useUser();
  const [refund, setRefund] = useState(false);

  const { mutate: endVisitRequest, isPending } = useEndVisit({ onSuccess: () => navigation.goBack() });

  const onEnd = useCallback(() => {
    endVisitRequest({ body: { refundMoney: refund }, params: { id: activeVisitId } });
  }, [endVisitRequest, refund, activeVisitId]);

  return (
    <AppModal title={'پایان مشاوره'}>
      <AppTextView text={'آیا برای پایان و خروج از صفحه مشاوره اطمینان دارید؟'} variant={'title'} textColor={'grey_light'} />
      <MarginBox>
        {userType === UserTypeEnum.DOCTOR && <AppSwitch label={'هزینه ویزیت به بیمار بازگشت داده شود'} value={refund} onValueChange={(value) => setRefund(value)} />}
        <Container flexDirection={'row'} fullWidth justifyContent={'space-around'}>
          <Button title={'بله'} loading={isPending} onPress={onEnd} />
          <Button title={'خیر'} variant={'red'} onPress={() => navigation.goBack()} />
        </Container>
      </MarginBox>
    </AppModal>
  );
}

const Container = styled(Box)`
  margin-top: 30px;
`;

const Button = styled(AppButton)`
  flex: 1;
  margin-horizontal: 5px;
`;

const MarginBox = styled(Box)`
  margin-top: 50px;
`;
